import React, { useMemo } from 'react';
import { Steps as AntdSteps } from 'antd';
import { useTranslation } from 'react-i18next';

export function Steps({ current }) {
  const { t, i18n } = useTranslation();
  const steps = useMemo(() => [
    {
      title: <span>{t('step.first')}</span>,
      content: 'First-content',
      key: t('step.first'),
    },
    {
      title: <span>{t('step.second')}</span>,
      content: 'Second-content',
      key: t('step.second'),
    },
  ], [i18n.language]);

  return (
    <AntdSteps current={current}>
      {steps.map((item) => (
        <AntdSteps.Step
          key={item.title}
          title={item.key}
        />
      ))}
    </AntdSteps>
  );
}
